import {useMemo} from "react";

export const useDomain = () => {
  return useMemo(() => {
    return window.location.hostname;
  }, []);
};